import { render, staticRenderFns } from "./CardFoodDiary.vue?vue&type=template&id=c5e0a94e&scoped=true"
import script from "./CardFoodDiary.vue?vue&type=script&lang=js"
export * from "./CardFoodDiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e0a94e",
  null
  
)

export default component.exports